import mbg1 from "../assets/mbg1.png";
import mbg2 from "../assets/mbg2.jpg";
import mbg3 from "../assets/mbg3.png";
import mbg4 from "../assets/mbg4.png";
import mbg5 from "../assets/mbg5.jpg";
import mbg6 from "../assets/mbg6.jpg";

export default function DetailGizi() {
  return (
    <>
        <section className="text-gray-600 body-font">
            <div className="container px-5 py-24 mx-auto">
                <div className="flex flex-wrap -m-4">
                <div className="p-4 md:w-1/3">
                    <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                    <img className="lg:h-72 md:h-54 w-full object-cover object-center" src={mbg1} alt="Foto makanan"/>
                    <div className="p-6">
                        <h1 className="title-font text-lg font-medium text-gray-900 mb-3">Kandungan gizi</h1>
                        <h3 className="font-semibold text-gray-800">Isi Makanan:</h3>
                        <ul className="list-disc ml-6">
                            <li>Telur orak-arik (scrambled/omelet strip)</li>
                            <li>Selada + timun</li>
                            <li>Nugget ayam goreng</li>
                            <li>Nasi kuning</li>
                            <li>Pisang</li>
                            <li>Susu kotak rasa cokelat</li>
                        </ul>

                        <h3 className="font-semibold text-gray-800 mt-3">Informasi Nilai Gizi (estimasi per porsi):</h3>
                        <ul className="list-disc ml-6">
                            <li>Energi:  <strong>350 kkal</strong></li>
                            <li>Protein: <strong>12 g</strong></li>
                            <li>Lemak total: <strong>8 g</strong> (lemak jenuh 2 g)</li>
                            <li>Karbohidrat total: <strong>45 g</strong> (serat 4 g, gula 6 g)</li>
                            <li>Natrium: <strong>320 mg</strong></li>
                            <li>Kalsium: <strong>110 mg</strong></li>
                            <li>Zat Besi: <strong>2 mg</strong></li>
                            <li>Vitamin C: <strong>15 mg</strong></li>
                        </ul>
                        <div className="flex items-center flex-wrap ">
                        </div>
                    </div>
                    </div>
                </div>

                <div className="p-4 md:w-1/3">
                    <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                    <img className="lg:h-72 md:h-54 w-full object-cover object-center" src={mbg2} alt="Foto makanan"/>
                    <div className="p-6">
                        <h1 className="title-font text-lg font-medium text-gray-900 mb-3">Kandungan Gizi</h1>
                        <h3 className="font-semibold text-gray-800">Isi Makanan:</h3>
                        <ul className="list-disc ml-6">
                            <li>Telur orak-arik / telur suwir</li>
                            <li>Selada + irisan timun</li>
                            <li>Nugget ayam goreng</li>
                            <li>Nasi kuning</li>
                            <li>Pisang</li>
                            <li>Susu kotak rasa cokelat</li>
                        </ul>
                        <h3 className="font-semibold text-gray-800 mt-3">Informasi Nilai Gizi (estimasi per porsi):</h3>
                        <ul className="list-disc ml-6">
                            <li>Energi: <strong> 520-580 kkal</strong></li>
                            <li>Protein: <strong> 20-4 g</strong></li>
                            <li>Lemak total: <strong> 18-22 g</strong> (lemak jenuh ≈ 6 g)</li>
                            <li>Karbohidrat total: <strong> 75-85 g</strong></li>
                            <li>Serat: <strong> 6 g</strong></li>
                            <li>Gula total: <strong> 20-25 g</strong></li>
                            <li>Natrium: <strong> 550-650 mg</strong></li>
                            <li>Kalsium: <strong> 200-300 mg</strong></li>
                            <li>Zat Besi: <strong> 2 mg</strong></li>
                        </ul>
                        <div className="flex items-center flex-wrap">
                        </div>
                    </div>
                    </div>
                </div>
                <div className="p-4 md:w-1/3">
                    <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                    <img className="lg:h-72 md:h-54 w-full object-cover object-center" src={mbg3} alt="Foto makanan"/>
                    <div className="p-6">
                        <h1 className="title-font text-lg font-medium text-gray-900 mb-3">Kandungan gizi</h1>
                        <h3 className="font-semibold text-gray-800">Isi Makanan:</h3>
                        <ul className="list-disc ml-6">
                            <li>Kentang rebus mini </li>
                            <li>Mie goreng</li>
                            <li>Buah potong </li>
                            <li>Telur dadar </li>
                            <li>Susu kotak </li>
                        </ul>
                        <h3 className="font-semibold text-gray-800 mt-3">Informasi Nilai Gizi (estimasi per porsi):</h3>
                        <ul className="list-disc ml-6">
                            <li>Energi: <strong> 480-560 kkal</strong></li>
                            <li>Protein: <strong> 14-16 g</strong></li>
                            <li>Lemak total: <strong> 14-17 g</strong> (lemak jenuh ≈ 4 g)</li>
                            <li>Karbohidrat total: <strong> 80-90 g</strong></li>
                            <li>Serat: <strong> 4-5 g</strong></li>
                            <li>Gula total: <strong> 18-22 g</strong></li>
                            <li>Natrium: <strong> 650-800 mg</strong> (mie goreng menyumbang natrium tinggi)</li>
                            <li>Vitamin C: <strong> 10-15 mg</strong></li>
                        </ul>
                        <div className="flex items-center flex-wrap ">
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="container px-5 py-24 mx-auto">
                <div className="flex flex-wrap -m-4">
                <div className="p-4 md:w-1/3">
                    <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                    <img className="lg:h-72 md:h-54 w-full object-cover object-center" src={mbg4} alt="Foto makanan"/>
                    <div className="p-6">
                        <h1 className="title-font text-lg font-medium text-gray-900 mb-3">Kandungan gizi</h1>
                        <h3 className="font-semibold text-gray-800">Isi Makanan:</h3>
                        <ul className="list-disc ml-6">
                            <li>Nasi putih</li>
                            <li>Daging tumis berbumbu</li>
                            <li>Tumis buncis dan wortel</li>
                            <li>Jeruk</li>
                            <li>Susu kotak UHT</li>
                        </ul>

                        <h3 className="font-semibold text-gray-800 mt-3">Informasi Nilai Gizi (estimasi per porsi):</h3>
                        <ul className="list-disc ml-6">
                            <li>Energi: <strong>520-600 kkal</strong></li>
                            <li>Protein: <strong>20-26 g</strong></li>
                            <li>Lemak total: <strong>14-20 g</strong> (lemak jenuh ± 5 g)</li>
                            <li>Karbohidrat total: <strong>80-90 g</strong></li>
                            <li>Serat: <strong>5-6 g</strong></li>
                            <li>Gula total: <strong>18-24 g</strong></li>
                            <li>Natrium: <strong>550-700 mg</strong></li>
                            <li>Kalsium: <strong>250-300 mg</strong></li>
                            <li>Zat Besi: <strong>2-3 mg</strong></li>
                        </ul>
                        <div className="flex items-center flex-wrap ">
                        </div>
                    </div>
                    </div>
                </div>

                <div className="p-4 md:w-1/3">
                    <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                    <img className="lg:h-72 md:h-54 w-full object-cover object-center" src={mbg5} alt="Foto makanan"/>
                    <div className="p-6">
                        <h1 className="title-font text-lg font-medium text-gray-900 mb-3">Kandungan Gizi</h1>
                        <h3 className="font-semibold text-gray-800">Isi Makanan:</h3>
                        <ul className="list-disc ml-6">
                            <li>Nasi putih</li>
                            <li>Tumis daging potong kecil</li>
                            <li>Telur orak-arik</li>
                            <li>Sayur hijau berkuah</li>
                            <li>Jeruk</li>
                        </ul>

                        <h3 className="font-semibold text-gray-800 mt-3">Informasi Nilai Gizi (estimasi per porsi):</h3>
                        <ul className="list-disc ml-6">
                            <li>Energi: <strong>500-580 kkal</strong></li>
                            <li>Protein: <strong>22-28 g</strong></li>
                            <li>Lemak total: <strong>16-22 g</strong> (lemak jenuh ± 5-6 g)</li>
                            <li>Karbohidrat total: <strong>70-85 g</strong></li>
                            <li>Serat: <strong>4-5 g</strong></li>
                            <li>Gula total: <strong>15-20 g</strong></li>
                            <li>Natrium: <strong>500-650 mg</strong></li>
                            <li>Kalsium: <strong>80-120 mg</strong></li>
                            <li>Zat Besi: <strong>2-3 mg</strong></li>
                        </ul>
                        <div className="flex items-center flex-wrap">
                        </div>
                    </div>
                    </div>
                </div>
                <div className="p-4 md:w-1/3">
                    <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                    <img className="lg:h-72 md:h-54 w-full object-cover object-center" src={mbg6} alt="Foto makanan"/>
                    <div className="p-6">
                        <h1 className="title-font text-lg font-medium text-gray-900 mb-3">Kandungan gizi</h1>
                        <h3 className="font-semibold text-gray-800">Isi Makanan:</h3>
                        <ul className="list-disc ml-6">
                            <li>Nasi goreng sayur</li>
                            <li>Telur mata sapi</li>
                            <li>Telur orak-arik (porsi kecil)</li>
                            <li>Selada dan irisan timun</li>
                            <li>Stroberi</li>
                            <li>Susu kotak anak</li>
                        </ul>

                        <h3 className="font-semibold text-gray-800 mt-3"> Informasi Nilai Gizi (estimasi per porsi):</h3>
                        <ul className="list-disc ml-6">
                            <li>Energi: <strong>550-650 kkal</strong></li>
                            <li>Protein: <strong>18-24 g</strong></li>
                            <li>Lemak total: <strong>18-25 g</strong> (lemak jenuh ± 5-7 g)</li>
                            <li>Karbohidrat total: <strong>80-90 g</strong></li>
                            <li>Serat: <strong>4-6 g</strong></li>
                            <li>Gula total: <strong>20-28 g</strong></li>
                            <li>Natrium: <strong>600-750 mg</strong></li>
                            <li>Kalsium: <strong>200-280 mg</strong></li>
                            <li>Zat Besi: <strong>1.5-2.5 mg</strong></li>
                        </ul>
                        <div className="flex items-center flex-wrap ">
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
    </>
  );
}